import React from 'react'
import Helmet from 'react-helmet'
import icon from '../resources/icon.png'

const themeLinks = [
  { rel: 'icon', href: icon },
  { rel: 'stylesheet', href: '/css/materialize.min.css' },
  { rel: 'stylesheet', href: '/css/owl.carousel.min.css' },
  { rel: 'stylesheet', href: '/css/animate.css' },
  { rel: 'stylesheet', href: '/css/aos.css' },
  { rel: 'stylesheet', href: '/css/lity.min.css' },
  { rel: 'stylesheet', href: '/css/font-awesome.min.css' },
]

const styleLinks = themeLinks.filter(link => link.rel === 'stylesheet')

// attach load listeners
styleLinks.forEach(link => {
  link.onload = 'onStyleLoad()'
})

let numLoaded = 0
global.onStyleLoad = function onStyleLoaded() {
  numLoaded++
  if (numLoaded === styleLinks.length) {
    // hide loader as soon as styles are available
    document.querySelector('.pre-loader').className += ' fade-out'
  }
}

function Head() {
  return (
    <Helmet
      title="Conf One | Your number one application for conference"
      meta={[
        {
          name: 'description',
          content: 'Your number one application for conference',
        },
        { name: 'keywords', content: 'conference,app,schedule,attendees' },
        { name: 'robots', content: 'index, follow' },
        { name: 'author', content: 'instea.co' },
      ]}
      link={themeLinks}
    />
  )
}

export default Head



// WEBPACK FOOTER //
// ./src/components/Head.js